import { LibreBotWidget } from './widget';
import { LibreBotConfig } from './types';
import { SupportedLang } from './translations';

// Auto-initialize from script tag
(async function () {
  // Find the script tag - document.currentScript may be null with defer
  const script = document.currentScript as HTMLScriptElement
    || document.querySelector('script[data-key][src*="librebot"]') as HTMLScriptElement;

  if (!script) {
    console.warn('LibreBot: Could not find script tag');
    return;
  }

  const apiKey = script.dataset.key || script.dataset.apiKey || '';
  const apiUrl = script.dataset.apiUrl || 'https://api.librebot.io';

  if (!apiKey) {
    console.error('LibreBot: Missing data-key attribute');
    return;
  }

  // Build config with ONLY the values explicitly provided via data attributes
  // This ensures userProvidedConfig in widget.ts only contains keys the user actually set
  // Remote config loading happens inside LibreBotWidget and will fill in the rest
  const config: Partial<LibreBotConfig> = {
    apiKey,
    apiUrl,
    streaming: script.dataset.streaming !== 'false',
    autoLoadConfig: true, // Enable remote config loading inside the widget
  };

  // Only add to config if data attribute is explicitly provided
  if (script.dataset.position) config.position = script.dataset.position as 'bottom-right' | 'bottom-left';
  if (script.dataset.theme) config.theme = script.dataset.theme as 'light' | 'dark' | 'auto';
  if (script.dataset.color) config.primaryColor = script.dataset.color;
  if (script.dataset.title) config.title = script.dataset.title;
  if (script.dataset.subtitle) config.subtitle = script.dataset.subtitle;
  if (script.dataset.placeholder) config.placeholder = script.dataset.placeholder;
  if (script.dataset.welcome) config.welcomeMessage = script.dataset.welcome;
  if (script.dataset.lang) config.lang = script.dataset.lang as SupportedLang;

  // Initialize when DOM is ready
  const initWidget = () => {
    (window as any).LibreBot = new LibreBotWidget(config as LibreBotConfig);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWidget);
  } else {
    initWidget();
  }
})();

// Export for manual initialization
export { LibreBotWidget, LibreBotConfig };
